module.exports = __webpack_public_path__ + "img/cartel-rep-dominicana.c6dce661.png";